import React from 'react';
import { LinkedIn } from '@mui/icons-material';

function SourceIcon({ source }: { source: string }) {
  switch (source) {
    case 'linkedin':
      return <LinkedIn color="primary" />;
    default:
      return (
        <div
          style={{
            width: '25px',
            height: '25px',
            backgroundImage: "url('/images/st-logo.png')",
            backgroundSize: '100% 100%'
          }}
        />
      );
  }
}

// eslint-disable-next-line react/display-name
const SourceIconLink = React.memo(({ source, url }: { source: string; url: string }) => {
  return (
    <a href={url} target="_blank" rel="noopener noreferrer">
      <SourceIcon source={source} />
    </a>
  );
});

export default SourceIconLink;
